import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { pageCardSx } from './formStyles';

export const createEditPageShellSx = {
  width: '100%',
  maxWidth: { xs: '100%', lg: 1360, xl: 1280 },
  boxSizing: 'border-box',
  mx: 'auto',
  px: { xs: 0.5, sm: 1, lg: 3, xl: 4 },
};

export const createEditPageHeaderSx = {
  mb: 4,
};

export const createEditBackButtonSx = {
  minWidth: 'fit-content',
  color: '#1C1B1F',
  textTransform: 'none',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  px: 0.5,
  mb: 2,
};

export const createEditPageTitleSx = {
  fontSize: '34px',
  lineHeight: '40px',
  letterSpacing: '-0.25px',
  fontWeight: 700,
  color: '#1C1B1F',
  mb: 1,
};

export const createEditPageSubtitleSx = {
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#1C1B1F',
};

export const createEditCardSx = {
  ...pageCardSx,
  p: { xs: 2.5, sm: 4 },
};

export const createEditFooterSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  mt: { xs: 5, md: 6 },
};

export const createEditCancelButtonSx = {
  textTransform: 'none',
  color: '#294190',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  px: 0,
};

export const createEditPrimaryButtonSx = {
  minWidth: 160,
  height: 40,
  borderRadius: '10px',
  textTransform: 'none',
  bgcolor: '#294190',
  color: '#FFFFFF',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: '#294190',
    boxShadow: 'none',
  },
};

export function CreateEditBackButton({ onClick, icon, children = 'Back' }) {
  return (
    <Button onClick={onClick} startIcon={icon} sx={createEditBackButtonSx}>
      {children}
    </Button>
  );
}

export function CreateEditPageTitleBlock({ title, subtitle }) {
  return (
    <Box>
      <Typography className="app-page-title" sx={createEditPageTitleSx}>
        {title}
      </Typography>
      {subtitle ? <Typography sx={createEditPageSubtitleSx}>{subtitle}</Typography> : null}
    </Box>
  );
}
